import { useRequest } from 'ahooks';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { getDataService, type IPlanDetail } from '../service.js';

const usePlanDetailData = (
  id?: string,
  payload?: { onSuccess?: (res?: IPlanDetail) => void }
) => {
  const { data } = useRequest(
    async () => (id ? await getDataService({ id }) : undefined),
    {
      refreshDeps: [id],
      onSuccess(res) {
        payload?.onSuccess?.(res);
      },
    }
  );
  const startTime = useMemo(
    () => dayjs(data?.startTime).startOf('day'),
    [data?.startTime]
  );
  const endTime = useMemo(
    () => dayjs(data?.endTime).endOf('day'),
    [data?.endTime]
  );

  return {
    startTime,
    endTime,
    data,
  };
};

export default usePlanDetailData;
